import * as actionTypes from '@store/common/action-types';

export const setFilters = (data) => async (dispatch) => {
	dispatch({
		type: actionTypes.SET_FILTERS,
		payload: data
	});
};
